import { useScroll } from 'hooks/scroll';
import React, { useEffect, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';
import cx from 'classnames';
import './menu.less';

export interface MenuProps {
    style?: React.CSSProperties;
    className?: string;
    menuList: {
        level: number;
        title: string;
        hash: string;
    }[];
    nodeList: HTMLHeadElement[];
}

export function Menu(props: MenuProps) {
    const { menuList, nodeList } = props;
    const [activeHead, setActiveHead] = useState<HTMLHeadElement | null>(null);
    const nodeRef = useRef(nodeList);
    nodeRef.current = nodeList;

    function getActiveHead() {
        const nodeList = nodeRef.current;
        let lastY = -10;
        let lastNode: any = null;
        for (let i = 0; i <= nodeList.length; i++) {
            const item = nodeList[i] || null;
            // 最后一个节点
            if (item === null) {
                setActiveHead(lastNode);
                return;
            }
            // 第一个节点
            const rect = item.getBoundingClientRect();
            if (lastNode === null && rect.y > 5) {
                setActiveHead(item);
                return;
            }
            if (lastY < 5 && rect.y >= 5) {
                setActiveHead(lastNode);
                return;
            }
            lastNode = item;
            lastY = rect.y;
        }
    }

    useEffect(() => {
        getActiveHead();
    }, [menuList, nodeList]);

    useScroll(getActiveHead, 100);

    const [anchorStyle, setAnchorStyle] = useState({
        top: 2,
        height: 22,
    });
    const propStyle = useSpring(anchorStyle);
    useEffect(() => {
        if (activeHead) {
            const a = document.querySelector(`[href='#${activeHead.id}']`) as HTMLLinkElement;
            if (a) {
                const height = a.getBoundingClientRect().height;
                setAnchorStyle({
                    top: a.offsetTop,
                    height,
                });
            }
        }
    }, [activeHead]);

    return (
        <div id="md-menu" className={cx('md-menu', props.className)} style={props.style}>
            <ul>
                {menuList.map((item) => (
                    <li
                        key={item.hash}
                        className={cx(`menu-level-${item.level}`, {
                            active: item.hash === '#' + activeHead?.id,
                        })}
                    >
                        <a
                            style={{
                                marginLeft: (item.level - 2) * 16,
                            }}
                            href={item.hash}
                        >
                            {item.title}
                        </a>
                    </li>
                ))}
                {<animated.i className="active-cursor" style={propStyle} />}
            </ul>
        </div>
    );
}
